import { LoaderNormal1 } from '@banksalad/bpl-web';

export const Loader = () => (
  <div style={{ height: '100vh', paddingTop: '160px' }}>
    <LoaderNormal1 />
  </div>
);
